import module from 'module';
import moment from 'moment';

import templateUrl from './report-data-preparation-status.template.html';

class ReportDataPreparationStatusComponent {
  constructor($scope) {
    this.$scope = $scope;
  }

  $onInit() {
    this.$scope.$watch('$ctrl.state', () => {
      if (!this.state || this.state.status !== 'RUNNING') return;
      this.eta = this.getEta();
    });
  }

  toLocalMoment(instant) {
    return instant ? moment.utc(instant).local() : null;
  }

  calculatePercentageProgress() {
    if (!this.state.totalCount) return 0;
    return this.state.processedCount / this.state.totalCount * 100;
  }

  calculateEta(state) {
    if (!state.startedAt) return null;
    if (!state.totalCount || state.processedCount <= 0) return null;

    const started = moment(state.startedAt);
    const now = moment();

    const elapsedSeconds = now.diff(started, 'seconds');
    if (elapsedSeconds <= 0) return null;

    const ratePerSecond = state.processedCount / elapsedSeconds;
    if (ratePerSecond <= 0) return null;

    const remaining = state.totalCount - state.processedCount;
    if (remaining <= 0) return 0;

    const totalSeconds = remaining / ratePerSecond;

    return Math.round(totalSeconds);
  }

  getEta() {
    const totalSeconds = this.calculateEta(this.state);
    if (totalSeconds === null) return null;

    const duration = moment.duration(totalSeconds, 'seconds');
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const secs = duration.seconds();

    return `${hours > 0 ? hours + 'h ' : ''}${minutes}m ${secs}s`;
  }
}

module.component('reportDataPreparationStatus', {
  templateUrl: templateUrl,
  bindings: {
    state: '<'
  },
  controller: ReportDataPreparationStatusComponent
});
